import EdButton from "@/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";

export interface InvestingThings {
  imageUrl: string | React.ReactNode;
  title?: string;
  description: string;
  knowMoredata?: IKnowMoredata;
}

export interface IKnowMoredata {
  title?: string;
  knowmoreTabledata?: {
    heading?: string | JSX.Element;
    description?: string | JSX.Element;
  }[];
  subHeading?: string;
  sideDescription?: string;
}

interface InvestingThingsProps {
  setKnowmoreData?: Function;
  investThingData: InvestingThings[];
  isboximage?: boolean;
  isButtonShow?: boolean;
  backgroundClass?: string;
  isboximageBack?: string;
  flexporpertyClass?: boolean;
  parentClassName?: string;
  setOpenKey?: Function;
  inview?: boolean;
  isAnimation?: boolean;
}

const InvestingThingsCard: React.FC<InvestingThingsProps> = ({
  setKnowmoreData,
  investThingData,
  isboximage,
  isButtonShow,
  backgroundClass,
  isboximageBack,
  flexporpertyClass,
  parentClassName,
  setOpenKey,
  inview,
  isAnimation,
}) => {
  return (
    <Row
      className={
        parentClassName
          ? `${parentClassName} mx-0 investingthings-section w-100`
          : "mx-0 investingthings-section"
      }
    >
      {investThingData.map((bond: any, index: any) => (
        <Col
          lg={12}
          md={12}
          sm={12}
          className={`${
            inview ? `fade-in-bottom fade-in-bottom-${index + 3} ` : ""
          }  ${isAnimation ? "visible0" : ""}  ${
            flexporpertyClass
              ? `${backgroundClass} grid-1-investingthings-section`
              : `${backgroundClass} grid-investingthings-section`
          }`}
          key={index}
        >
          <div className="investingthing-outer-imgbox">
            {isboximage ? (
              <div className={`${isboximageBack} image-box`}>
                <img src={bond.imageUrl} alt={bond.title} />
              </div>
            ) : (
              <div>
                <img src={bond.imageUrl} alt={bond.title} />
              </div>
            )}
            <div className="investingthing-outer-content">
              {bond.title && (
                <span className="common-title d-flex">{bond.title}</span>
              )}
              <span className="common-desc" title={bond.description}>
                {bond.description}
              </span>
              {isButtonShow && (
                <div className="mgt-20">
                  <EdButton
                    value="Know more"
                    btnTyp={"link"}
                    className="btn-orange-border px-30 bg-transparent"
                    onClick={() => {
                      setOpenKey && setOpenKey(true);
                      setKnowmoreData && setKnowmoreData(bond.knowMoredata);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default InvestingThingsCard;
